import React, { useState, useEffect } from "react";
import { Card, Row, Col, Button, Modal, Spin, Table } from "antd";
import { RiEditFill, RiDeleteBin2Fill } from "react-icons/ri";
import { getAllConstants, deleteConstantById } from "@api/workspace/constant";
import {
  SuccessNotification,
  ErrorNotification,
  ConstantCreateModal,
  ConstantUpdateModal,
} from "@components";

const ConstantsList = () => {
  const [constants, setConstants] = useState([]);
  const [loading, setLoading] = useState(false);
  const [createModalOpen, setCreateModalOpen] = useState(false);
  const [updateModalOpen, setUpdateModalOpen] = useState(false);
  const [constantId, setConstantId] = useState("");

  // Fetch all constants
  useEffect(() => {
    const fetchConstants = async () => {
      setLoading(true);
      try {
        const { data } = await getAllConstants();
        setConstants(data);
      } catch (error) {
        console.error("Fetch constants error", error);
      } finally {
        setLoading(false);
      }
    };

    fetchConstants();
  }, []);

  // Handle create constant modal
  const handleCreateModalClick = () => {
    setCreateModalOpen(!createModalOpen);
  };

  // Handle update constant modal
  const handleUpdateModalClick = (id) => {
    setConstantId(id);
    setUpdateModalOpen(!updateModalOpen);
  };

  // Fetch all constants
  const fetchConstants = async () => {
    setLoading(true);
    const { data } = await getAllConstants();
    setConstants(data);
    setLoading(false);
  };

  // Handle constant delete
  const handleConstantDelete = (id) => {
    // Confirm delete
    Modal.confirm({
      title: "Are you sure you want to delete this constant?",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk: async () => {
        try {
          await deleteConstantById(id);
          // Fetch all constants
          fetchConstants();
          // Show success notification
          SuccessNotification("Constant deleted successfully");
        } catch (error) {
          // Show error notification
          ErrorNotification("Error deleting constant");
        }
      },
    });
  };

  // Table columns
  const columns = [
    {
      title: "Constant Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Constant Value",
      dataIndex: "value",
      key: "value",
    },
    {
      title: "Action",
      key: "action",
      render: (_, constant) => (
        <>
          <RiEditFill
            onClick={() => handleUpdateModalClick(constant._id)}
            style={{ cursor: "pointer", marginRight: 10 }}
          />
          <RiDeleteBin2Fill
            onClick={() => handleConstantDelete(constant._id)}
            style={{ cursor: "pointer" }}
          />
        </>
      ),
    },
  ];

  return (
    <>
      {/* Create Constant Modal */}
      {createModalOpen && (
        <ConstantCreateModal
          open={createModalOpen}
          handleModalClick={handleCreateModalClick}
          fetchConstants={fetchConstants}
        />
      )}

      {/* Update Constant Modal */}
      {updateModalOpen && (
        <ConstantUpdateModal
          open={updateModalOpen}
          handleModalClick={handleUpdateModalClick}
          fetchConstants={fetchConstants}
          constantId={constantId}
        />
      )}

      <Card style={{ borderRadius: "0", height: "100vh" }}>
        <Row justify="space-between">
          <Col>
            <h3>Constants List</h3>
          </Col>
          <Col>
            <Button type="primary" onClick={handleCreateModalClick}>
              Create Constant
            </Button>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            {loading ? (
              <Spin
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "80vh",
                }}
              />
            ) : (
              <Table
                dataSource={constants}
                columns={columns}
                rowKey={(record) => record._id}
              />
            )}
          </Col>
        </Row>
      </Card>
    </>
  );
};

export default ConstantsList;
